// extracted by mini-css-extract-plugin
module.exports = {"url-input":"SparqlFetch_url-input__1oboI","query-input-here":"SparqlFetch_query-input-here__3R4YC","base-iri-input-here":"SparqlFetch_base-iri-input-here__3PfTF"};